<div *ngIf="isLoading">
  <div style="
      position: fixed;
      z-index: 900;
      width: 100vw;
      height: 100vh;
      opacity: 80;
      top: 0;
      left: 0;
      background: #e8e8e880;
    "></div>
  <mat-spinner class="spinner-center" style="z-index: 1000"></mat-spinner>
</div>
<div *ngIf="data_report">
  <!-- [ngStyle]="isLoading ? { visibility: 'hidden' } : { visibility: 'visible' }" -->
  <div>
    <div *ngFor="let item of data_report">
      <div class="container">
        <div class="row justify-content-center" style="padding: 5% 0">
          <h1 class="lifedi-color" style="font-weight: bold">
            {{ item.reportname }}
          </h1>
        </div>
        <h2 style="text-decoration: underline; font-weight: bold">
          {{ item.measure_name }}
        </h2>
        <h3>
          {{ item.report_description }}
        </h3>
        <div *ngFor="let data of item.data">
          <h2 style="
              text-decoration: underline;
              font-weight: bold;
              text-align: center;
            ">
            {{ data.ideal_type }}
          </h2>
          <div *ngFor="let ideal of data.ideal_data; let j = index" class="justify-content-center"
            style="padding: 2% 0">
            <div style="
                position: absolute;
                left: -5000px;
                width: 610px;
                height: 131px;
              ">
              <div class="normalcase" *ngIf="
                  ideal.ideal_value > ideal.value ||
                  ideal.ideal_value == ideal.value
                ">
                <div id="sliderpdf{{ ideal.id }}" class="custom-slider" style="width: 60%">
                  <ngx-slider value="{{ ideal.value | number: '1.2-2' }}" highValue="{{ ideal.ideal_value }}"
                    [options]="options[j]" style="margin: 0 auto"></ngx-slider>
                </div>
              </div>
              <div class="specialcase" *ngIf="ideal.value > ideal.ideal_value">
                <div id="sliderpdf{{ ideal.id }}" class="custom-slider" style="width: 60%">
                  <ngx-slider value="{{ ideal.value | number: '1.2-2' }}" highValue="{{ ideal.ideal_value }}" [options]="options[j]"
                    style="margin: 0 auto"></ngx-slider>
                </div>
              </div>
            </div>
            <div class="row" style="padding-top: 5vh">
              <div class="col-lg-2 col-md-12 col-sm-12">
                <h2 class="topic" [ngStyle]="{ color: data.COLOR_CODE }"
                  style="font-weight: bold; text-decoration: underline" class="lifedi-color">
                  {{ ideal.psy_name }}
                </h2>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12 normalcase" *ngIf="
                  ideal.ideal_value > ideal.value ||
                  ideal.ideal_value == ideal.value
                ">
                <div id="slider{{ ideal.id }}" class="custom-slider" style="margin: 0 auto; width: 60%">
                  <ngx-slider value="{{ ideal.value | number: '1.2-2' }}" highValue="{{ ideal.ideal_value }}" [options]="options[j]"
                    style="margin: 0 auto"></ngx-slider>
                </div>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12 specialcase" *ngIf="ideal.value > ideal.ideal_value">
                <div id="slider{{ ideal.id }}" class="custom-slider" style="margin: 0 auto; width: 60%">
                  <ngx-slider value="{{ ideal.value | number: '1.2-2' }}" highValue="{{ ideal.ideal_value }}" [options]="options[j]"
                    style="margin: 0 auto"></ngx-slider>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-12">
                <h2 class="lifedi-color" style="font-weight: bold">
                  ท่านได้ {{ ideal.value | number: '1.2-2' }} คะแนน
                </h2>
                <h2 style="font-weight: bold; color: #ffc90e">
                  คะแนนที่เหมาะสม {{ ideal.ideal_value | number : '1.2-2' }} คะแนน
                </h2>
              </div>
            </div>
          </div>
        </div>
        <hr style="width: 70%; text-align: center" />
        <div *ngFor="let data of item.data">
          <h2 style="
              text-decoration: underline;
              font-weight: bold;
              text-align: center;
            ">
            {{ data.ideal_type }}
          </h2>
          <div *ngFor="let ideal of data.ideal_data" style="padding: 2% 0">
            <h2 class="lifedi-color" style="font-weight: bold; text-decoration: underline">
              {{ ideal.psy_name }}
            </h2>
            <h4 [innerText]="ideal.psy_description"></h4>
            <h2 style="font-weight: bold">
              คะแนนต่ำสุด : {{ ideal.min }} คะแนนสูงสุด : {{ ideal.max }}
            </h2>
            <h2 class="lifedi-color" style="font-weight: bold">
              ท่านได้ {{ ideal.value | number: '1.2-2' }} คะแนน
              <!-- อยู่ในช่วงคะแนน {{ ideal.range }} คะแนน -->
            </h2>
            <h4 style="padding-bottom: 3%" [innerText]="ideal.range_description"></h4>
            <hr style="width: 70%; text-align: center" />
          </div>
        </div>
        <div style="text-align: center; padding: 5% 0" *ngIf="data_report">
          <lifedi-btn lable="ดาวน์โหลด" (click)="downloadpdf()" customStyle="background: #005C3D; color: #FFFFFF; margin-top: 0px;
            padding: 0 25px;">
          </lifedi-btn>
        </div>
      </div>
    </div>
  </div>
</div>